import { Component, OnInit } from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

export interface Keynames {
    name: string;
}

@Component({
    selector: 'app-KeyAuth',
    templateUrl: './KeyAuth.component.html'
})

export class KeyAuthComponent implements OnInit {

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    // key: string[];
    key: string[] = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    Keynames: Keynames[] = [];
    // key_names: KeyNames[] = [{name: 'key1'}];
    consumerID: string;
    hide_credentials = false;
    anonymous: string;
    key_in_body = false;
    run_on_preflight = true;

    data = {
        'consumerID': this.consumerID,
        'key_names' : this.key,
        'hide_credentials': this.hide_credentials,
        'anonymous': this.anonymous,
        'key_in_body': this.key_in_body,
        'run_on_preflight': this.run_on_preflight,
        'plugin': 'key-auth'
    };

    constructor() { }


    slider() {
        this.hide_credentials = !this.hide_credentials;
}
    slider1() {
        this.key_in_body = !this.key_in_body;
    }
    slider2() {
        this.run_on_preflight = !this.run_on_preflight;
    }


    KeyAuth() {
    }

    ngOnInit() {
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.Keynames.push({name: value.trim()});
            const temp = value.trim();
            this.key.push(temp);
        }

        if (input) {
            input.value = '';
        }
    }

    remove(Keynames: Keynames): void {
        const index = this.Keynames.indexOf(Keynames);
        if (index >= 0) {
            this.Keynames.splice(index, 1);
            this.key.splice(index, 1);
        }
    }
}
